<script setup lang="ts">
import PersonalInformation from './PersonalInformation.vue'
import CvOrResume from './CvOrResume.vue'
import CoverLetter from './CoverLetter.vue'
import AdditionalQuestions from './AdditionalQuestions.vue'
import LegalAgreements from './LegalAgreements.vue'

defineOptions({
  name: 'TutorApplication',
})
</script>

<template>
  <div class="form-registration">
    <PersonalInformation />
    <CvOrResume />
    <CoverLetter />
    <AdditionalQuestions />
    <LegalAgreements />
  </div>
</template>

<style scoped lang="scss" src="./TutorApplication.scss" />
